export function initShowMenu(){
    const hamburger = document.querySelector<HTMLButtonElement>('.hamburger');
    if (!hamburger) return;

    hamburger.addEventListener('click', () => {
        document.body.classList.toggle('menu-active');
    });
}